import { render, staticRenderFns } from "./ABMCredito.vue?vue&type=template&id=331ba3cc&"
import script from "./ABMCredito.vue?vue&type=script&lang=js&"
export * from "./ABMCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports